/**
 * Enum of Dialog Confirmation Modes.
 */
export enum DialogConfirmMode {
  Delete = 'delete',
  Info = 'info',
  Revert = 'revert',
  Warn = 'warn'
}
